import Vue from 'vue';
import MetalPricesShortcode from './components/MetalPricesShortcode.vue';

new Vue({
  render: h => h(MetalPricesShortcode)
}).$mount('#metal-prices-root');